"use client";

import { createContext } from "react";

const defaultContextValue = {
  elementWrapperClassName: "",
  labelClassName: "",
  layout: "horizontal",
  rowClassName: "",
  validateBeforeSubmit: true,
  validatePristine: false,
};

const FrcContext = createContext(defaultContextValue);

FrcContext.displayName = "FrcContext";

export default FrcContext;
